import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-job-view',
  templateUrl: './job-view.component.html',
  styleUrls: ['./job-view.component.scss']
})
export class JobViewComponent {}
